import React from 'react';
import logo from '../assets/images/logo.png';

const APP_STORE_URL =
  'https://apps.apple.com/us/app/pictureit-draw-charades/id1514525835';
const PLAY_STORE_URL =
  'https://play.google.com/store/apps/details?id=com.devroldy.picture_it';

function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="footer">
      <div className="wrap">
        <div className="footer-top">
          {/* Brand */}
          <div className="footer-brand">
            <div className="footer-brand-mark">
              <img src={logo} alt="PictureIt Logo" />
            </div>
            <span className="footer-brand-name">PictureIt</span>
          </div>

          {/* Navigation */}
          <nav className="footer-nav">
            <a href="#features">Features</a>
            <a href="#how">How It Works</a>
            <a href="#platforms">Download</a>
            <a
              href={APP_STORE_URL}
              target="_blank"
              rel="noopener noreferrer"
            >
              App Store
            </a>
            <a
              href={PLAY_STORE_URL}
              target="_blank"
              rel="noopener noreferrer"
            >
              Google Play
            </a>
          </nav>

          {/* Social links */}
          <div className="footer-social">
            <a href="https://www.instagram.com/pictureit.app" target="_blank" rel="noopener noreferrer" aria-label="Instagram">
              <svg width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="rgba(255,255,255,0.5)" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <rect x="2" y="2" width="20" height="20" rx="5" ry="5" />
                <path d="M16 11.37A4 4 0 1 1 12.63 8 4 4 0 0 1 16 11.37z" />
                <line x1="17.5" y1="6.5" x2="17.51" y2="6.5" />
              </svg>
            </a>
          </div>
        </div>

        {/* Bottom bar */}
        <div className="footer-bottom">
          <span>&copy; {currentYear} PictureIt. All rights reserved.</span>
          <div className="footer-bottom-links">
            <a href="/privacy-policy">Privacy Policy</a>
            <a href="/terms-of-service">Terms of Service</a>
          </div>
        </div>
      </div>
    </footer>
  );
}

export default Footer;